module.exports = __webpack_public_path__ + "static/media/offers.abed265c.png";